<template>
  <section>
    <p>
      <strong>{{ $t('event.detail.label.name') }}：</strong><br>
      {{ event.name }}
    </p>
    <p>
      <strong>{{ $t('event.detail.label.start-date') }}：</strong><br>
      {{ event.start_date.slice(0, 10) }}
      <span v-if="event.start_date_note">{{ event.start_date_note }}</span>
    </p>
    <p>
      <strong>{{ $t('event.detail.label.end-date') }}：</strong><br>
      {{ event.end_date.slice(0, 10) }}
      <span v-if="event.end_date_note">{{ event.end_date_note }}</span>
    </p>
    <p>
      <strong>{{ $t('event.detail.label.venue') }}：</strong><br>
      <span>財團法人佛陀教育基金會 華藏教學園區<br>[新北市深坑區阿柔里5鄰大崙尾9號]</span>
    </p>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar>
    <b-card no-body>
      <b-tabs pills card>
        <b-tab :title="$t('event.detail.livestream.schedule.title')" active>
          <b-form>
            <b-input-group size="lg">
              <b-input-group-prepend>
                <b-input-group-text style="border-color: black;">
                  <strong style="color: blue">{{ $t('event.detail.livestream.schedule.date-selector.label') }}</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select
                size="lg"
                style="border-color: black; color: black"
                v-model="live_streaming_schedules_filter.schedule_date"
              >
                <b-form-select-option
                  :value="schedule_date"
                  v-for="schedule_date in schedule_dates"
                >{{ schedule_date }}</b-form-select-option>
              </b-form-select>
            </b-input-group>
          </b-form>
          <event-schedule-list :schedules="live_streaming_schedules"></event-schedule-list>
        </b-tab>
        <b-tab :title="$t('event.detail.handout.list.title')" v-if="handouts.length > 0">
          <event-handout-list :handouts="handouts" v-if="handouts.length > 0"></event-handout-list>
        </b-tab>
      </b-tabs>
    </b-card>
  </section>
</template>

<script>
import Vue from 'vue'

import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import lodash from 'lodash'

import { stringify } from 'query-params-helpers'
import { CardPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'
import EventHandoutList from '@/components/lists/EventHandoutList'
import EventScheduleList from '@/components/lists/EventScheduleList'

import i18n from '@/plugins/i18n.js'

import EventApiService from '@/services/budaedu-api-services/event-api-service.js'

Vue.use(lodash)
Vue.use(CardPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(InputGroupPlugin)
Vue.use(TabsPlugin)

Vue.use(EventApiService)

export default {
  i18n,
  name: 'event-live-streaming-info',
  props: {
    event: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      live_streaming_schedules_filter: {
        schedule_date: '',
        has_live_stream: 'Y'
      },
      handouts: [],
      live_streaming_schedules: []
    }
  },
  computed: {
    schedule_dates() {
      dayjs.extend(isSameOrBefore)
      const start_date = dayjs(this.event.start_date);
      const end_date = dayjs(this.event.end_date);
      const schedule_dates = [];

      let current_date = start_date;
      while (current_date.isSameOrBefore(end_date, 'day')) {
        schedule_dates.push(current_date.format('YYYY-MM-DD'));
        current_date = current_date.add(1, 'day');
      }

      return schedule_dates
    },
    social_sharing_title() {
      return `${this.event.name} 活動直播`
    },
    social_sharing_route() {
      return { name: 'event-live-streaming', params: { id: this.event.id } }
    }
  },
  watch: {
    "live_streaming_schedules_filter.schedule_date": {
      handler(new_value, old_value) {
        this.setLiveStreamingSchedules()
      }
    },
    "event": {
      handler(new_value, old_value) {
        if (new_value && new_value.id) {
          this.setHandouts()
          this.setLiveStreamingSchedules()

          gtag('event', `watch event live`, {
            code: this.event.id,
            name: this.event.name,
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    async setHandouts() {
      const items = await this.$eventApiService.fetchHandouts(this.event)
      this.handouts = items.data
    },
    async setLiveStreamingSchedules() {
      let params = stringify({
        include: 'places',
        filter: lodash.pickBy(this.live_streaming_schedules_filter, value => value !== ''),
        order: 'schedule_date,asc|start_time,asc'
      }).substr(1)

      const items = await this.$eventApiService.fetchSchedules(this.event, params)

      this.live_streaming_schedules = items.data
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    EventHandoutList,
    EventScheduleList,
    SocialSharingButtonToolbar
  }  
}
</script>